export enum GenericTableSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type GenericTableSort = {
  field: string | null
  direction: GenericTableSortDirection
}

export type GenericTableSelectAllScope = 'firstPage' | 'allLoaded' | 'allCollection'

export type GenericTableSelectAllCollectionChange = {
  selectAll: boolean
}

export type GenericTableSelectionChange<T> = {
  keys: string[]
  rows: T[]
}

export type GenericTableHeaderCheckboxState = 'none' | 'someSelected' | 'allSelected'

export type GenericTableColumnAlign = 'left' | 'center' | 'right'

export type GenericTableSkeletonLayout = 'row' | 'stack'

export type GenericTableFixedFirstColumnMode = false | true | 'below-xl' | 'below-lg'
